import Vue from 'vue';
import Vuex from 'vuex';

import tagsView from './modules/tagsView';
import message from './modules/message';

import {
    getUserInfoAjax
} from 'api/login'; // ajax api

import {
    superAdmin,
    zyzAdmin
} from '@/router/menu'; // 菜单

import {
    unique,
    arrObjUnique
} from '@/utils/public'; // 数组对象去重

// 路由配置

import rootConfig from '@/router/modules/root'; // 系统管理员
import zyzConfig from '@/router/modules/zyz'; // 系统管理员

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        tagsView,
        message
    },
    state: {
        menuCollapse: false, //菜单展开收起
        menuFixed: false, //固定导航
        isMenuDark: false, //深色系菜单
        menuType: 1, //导航模式
        contentWidthType: '流式', //内容宽度
        nickName: '', // 昵称
        account: '', // 账号
        token: '', // token
        head_img: './static/img/head.png', // 头像
        unread: '', // 未读消息
        role: '', // 用户角色组名称
        menu: [] // 用户路由表
    },
    getters: {
        visitedViews: state => state.tagsView.visitedViews,
        cachedViews: state => state.tagsView.cachedViews,
        // 根据权限动态加载菜单
        GenerateRoutes: state => {

            // if (state.role === '管理员') {
            return rootConfig;
            // } else if (state.role === '志愿者') {
            //     return zyzConfig;
            // } else if (state.role === '无权限用户') {
            //     return noRoleConfig;
            // }
        }
    },
    mutations: {
        // 菜单展开收起
        SET_MENU_COLLAPSE: function (state, new_menuCollapse) {
            this.state.menuCollapse = new_menuCollapse;
        },
        // 菜单展开收起
        SET_MENU_FIXED: function (state, new_menuFixed) {
            this.state.menuFixed = new_menuFixed;
        },
        // 菜单主题色
        SET_THEME: function (state, new_isMenuDark) {
            this.state.isMenuDark = new_isMenuDark;
        },
        // 导航模式
        SET_MENUTYPE: function (state, new_menuType) {
            this.state.menuType = new_menuType;
        },
        // 内容宽度
        SET_CONTENTWIDTH: function (state, new_contentWidthType) {
            this.state.contentWidthType = new_contentWidthType;
        },
        // 角色
        SET_ROLE: function (state, new_role) {
            this.state.role = new_role;
        },
        // token
        SET_TOKEN: function (state, new_token) {
            this.state.token = new_token;
        },
        // 菜单
        SET_MENU: function (state, new_menu) {
            this.state.menu = new_menu;
        },
        // 昵称
        SET_NICK_NAME: function (state, new_nickName) {
            this.state.nickName = new_nickName;
        },
        // 账号
        SET_ACCOUNT: function (state, new_account) {
            this.state.account = new_account;
        },
        // 未读信息
        SET_UNREAD: function (state, new_unread) {
            this.state.unread = new_unread;
        }
    },
    actions: {
        // 获取用户信息
        getUserInfo ({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                getUserInfoAjax()
                    .then(res => {
                        if (res.code === 200) {
                            const respon = res.data || '';
                            let roleStr = '';
                            let superAdminMenu = '';
                            let superAdminMenuAll = [];

                            if (respon.info.roles && respon.info.roles.length > 0) {
                                respon.info.roles.forEach(item => {
                                    // 用户角色
                                    roleStr += item.name + ',';
                                    // 整合当前用户的所有权限
                                    superAdminMenuAll = [...superAdminMenuAll, ...item.permissions];
                                });
                            }
                            let superAdminMenuStr = arrObjUnique(unique([...[], ...superAdminMenuAll]));

                            superAdminMenu = arrObjUnique(unique([...[], ...superAdminMenuAll]));

                            if (superAdminMenuStr.indexOf("报名管理") !== -1) {
                                if (superAdminMenuStr.indexOf("报名列表") < 0) {
                                    superAdminMenu = arrObjUnique(unique([...[], ...superAdminMenuAll])) + ",报名列表";
                                }
                            }

                            superAdmin.forEach(item => {

                                if (item.title === "工作台") {
                                    item.isShow = true;
                                } else if (item.title === "报名管理") {
                                    let itemBmLenght = 0;
                                    let yhscFlag = false;
                                    item.children.forEach(itemBm => {

                                        if (superAdminMenu.indexOf(itemBm.title) !== -1) {
                                            itemBm.isShow = true;

                                            if (itemBm.title === "报名列表") {
                                                yhscFlag = true;
                                            }

                                        } else {
                                            itemBm.isShow = false;
                                            if (itemBm.title === "报名列表") {
                                                yhscFlag = false;
                                            }
                                            ++itemBmLenght;
                                        }

                                        if (yhscFlag) {
                                            if (itemBm.title === "用户上传列表") {
                                                itemBm.isShow = true;
                                            }
                                        } else {
                                            if (itemBm.title === "用户上传列表") {
                                                itemBm.isShow = false;
                                            }
                                        }

                                    });

                                    if (item.children.length === itemBmLenght) {
                                        item.isShow = false;
                                    } else {
                                        item.isShow = true;
                                    }

                                } else if (item.title === "系统设置") {
                                    let itemXtLenght = 0;
                                    let xtszFlag = false;
                                    item.children.forEach(itemXt => {
                                        if (superAdminMenu.indexOf(itemXt.title) !== -1) {
                                            itemXt.isShow = true;
                                        } else {
                                            itemXt.isShow = false;

                                            ++itemXtLenght;
                                        }
                                    });

                                    if (item.children.length === itemXtLenght) {
                                        item.isShow = false;
                                        xtszFlag = false;
                                    } else {
                                        item.isShow = true;
                                        xtszFlag = true;
                                    }

                                    if (xtszFlag) {
                                        item.children.forEach(itemXt1 => {
                                            if (itemXt1.title === '站点信息' || itemXt1.title === '年份设置' || itemXt1.title === '语言设置' || itemXt1.title === '地点设置' || itemXt1.title === '申报组别设置' || itemXt1.title === '消息通知' || itemXt1.title === '奖项管理') {
                                                itemXt1.isShow = true;
                                            }
                                        });
                                    }
                                } else {
                                    if (superAdminMenu.indexOf(item.title) !== -1) {
                                        item.isShow = true;
                                    } else {
                                        item.isShow = false;
                                    }
                                }
                            });

                            commit('SET_ROLE', roleStr.slice(0, -1)); // 存储用户角色
                            commit('SET_MENU', superAdmin); // 存储用户菜单
                            commit('SET_NICK_NAME', respon.info.nickname); // nickName
                            commit('SET_ACCOUNT', respon.info.name); // account
                            // if(respon.info.name==='admin_volun'){
                            //     commit('SET_ROLE', '志愿者'); // 存储用户角色
                            //     commit('SET_MENU',zyzAdmin); // 存储用户菜单
                            // }
                            commit('SET_UNREAD', respon.un_read || 0); // 未读消息
                        }
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js